const contactItems = [
  {
    label: 'Address',
    icon: 'ri-map-pin-2-line',
    lines: ['Partizanska 57/17', 'BITOLA, 7000', 'North Macedonia'],
  },
  {
    label: 'Email',
    icon: 'ri-mail-line',
    lines: ['help@momasdoo.com'],
  },
  {
    label: 'Phone',
    icon: 'ri-phone-line',
    lines: ['+1 3185598700'],
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="bg-[#0A0A0A] py-28">
      <div className="max-w-[1400px] mx-auto px-16">
        {/* Big brand name */}
        <h2 className="text-[80px] font-bold text-white leading-none mb-20 tracking-tight">
          MOMAS D.O.O.
        </h2>

        {/* Main grid */}
        <div className="grid grid-cols-12 gap-8 pb-20 border-b border-[#2A2A2A]">
          {/* Left: intro + tagline */}
          <div className="col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 rounded-full bg-[#D4FF00]" />
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8A8A8A]">Get In Touch</span>
            </div>
            <p className="text-white/65 text-base leading-relaxed mb-10 max-w-sm">
              Developing innovative iOS applications focused on security and
              performance optimization for modern mobile users worldwide.
            </p>

            {/* Tags */}
            <div className="flex flex-wrap gap-3">
              {['iOS Development', 'Mobile Security', 'Performance', 'VPN', 'Cleaner'].map((tag) => (
                <span
                  key={tag}
                  className="border border-[#2A2A2A] text-white/50 text-xs px-3 py-1.5 rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Middle: contact details */}
          <div className="col-span-4 flex flex-col gap-10">
            {contactItems.map((item) => (
              <div key={item.label}>
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-[#D4FF00] text-base`} />
                  </div>
                  <span className="text-[#D4FF00] text-xs font-bold uppercase tracking-widest">{item.label}</span>
                </div>
                {item.lines.map((line) => (
                  <p key={line} className="text-white/80 text-base leading-7">{line}</p>
                ))}
              </div>
            ))}
          </div>

          {/* Right: image */}
          <div className="col-span-3">
            <div className="w-full rounded-2xl overflow-hidden" style={{ height: 300 }}>
              <img
                src="https://public.readdy.ai/ai/img_res/39df843da4a5ba77571635a9f3510db2.jpg"
                alt="MOMAS D.O.O. iOS apps"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Bottom copyright */}
        <div className="flex items-center justify-between pt-8">
          <p className="text-white/40 text-sm">
            &copy; {new Date().getFullYear()} MOMAS D.O.O. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-apple-fill text-white/40 text-base" />
            </div>
            <span className="text-white/40 text-sm">iOS Platform Specialists</span>
          </div>
        </div>
      </div>
    </section>
  );
}
